import {useQuery} from '@tanstack/react-query';
import {DcdOwnershipService, DcdOwnershipServiceSummary, TeamService} from 'client';
import {getService} from 'utilities';

export const useDcdOwnershipServices = () =>
  useQuery({
    queryKey: ['teams', 'ownership', 'services', 'servicenow'],
    queryFn: () =>
      getService(TeamService).getDcdOwnershipServicesApiV1TeamsOwnershipServicesGet(
        DcdOwnershipServiceSummary.source.SERVICENOW
      ),
    staleTime: 5 * 60 * 1000,
  });

export const useDcdOwnershipService = (serviceId?: number) =>
  useQuery<DcdOwnershipService>({
    queryKey: ['teams', 'ownership', 'services', serviceId],
    queryFn: () =>
      getService(TeamService).getDcdOwnershipServiceApiV1TeamsOwnershipServicesServiceIdGet(
        serviceId!
      ),
    enabled: serviceId !== undefined,
  });
